import { COLOR_NEUTRAL_DARKEST, COLOR_PRIMARY, COLOR_WH } from '../colors.constants';

export const colorsTooltip = {
  colorTooltipBackground: COLOR_NEUTRAL_DARKEST,
  colorTooltipText: COLOR_WH,
  colorTooltipTextAccent: COLOR_PRIMARY,
};
